module.exports = __webpack_public_path__ + "static/media/sticky-logo-3.27dfe519.png";